import { Button } from '@capcenter/shared';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ShareLink.scss'
import {  faCommentSms, faLink, faEnvelope, faShareFromSquare, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faXTwitter, faFacebook,  faLinkedin, faReddit, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { useRecoilValue } from 'recoil';
import * as AppState from '../../../AppState';


export function ShareLink({canonicalUrl}: {canonicalUrl: string}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

	const userOnMobile = useRecoilValue(AppState.gsIsMobile);

  // Define the properties for the popup window
  const maxWidth = 500; // Maximum width of the popup window
  const maxHeight = 600; // Maximum height of the popup window

  // Calculate the window width and height while respecting maximum values
  const windowWidth = Math.min(maxWidth, window.innerWidth);
  const windowHeight = Math.min(maxHeight, window.innerHeight);

  // Calculate the left and top positions for centering the popup
  const left = (window.innerWidth - windowWidth) / 2 + window.screenX;
  const top = (window.innerHeight - windowHeight) / 2 + window.screenY;

  // Create the popupOptions string
  const popupOptions = `width=${windowWidth},height=${windowHeight},left=${left},top=${top},toolbar=0,menubar=0,location=0,status=0,scrollbars=1,resizable=1`;
  const shareUrl = canonicalUrl

	const [urlCopied, setUrlCopied] = useState(false);
  const [emailShared, setEmailShared] = useState(false);
  const [textShared, setTextShared] = useState(false);
  const [facebookShared, setFacebookShared] = useState(false);
  const [twitterShared, setTwitterShared] = React.useState(false);
  const [linkedinShared, setLinkedinShared] = React.useState(false);
  const [redditShared, setRedditShared] = React.useState(false);
  const [whatsAppShared, setWhatsAppShared] = React.useState(false);

  function changeSharedButtonState(setSharedValueFunction: (value: boolean)=> any){
    setSharedValueFunction(true);
		setTimeout(function() {setSharedValueFunction(false);}, 5000);
  }

	function handleCopyUrlClick() {
		navigator.clipboard.writeText(shareUrl);
		changeSharedButtonState(setUrlCopied);
	}

  const shareViaEmail = () => {
    const emailSubject = encodeURIComponent("Check out this property listing!");
    const emailBody = encodeURIComponent(`Check out this property listing: ${shareUrl}`);
    window.location.href = `mailto:?subject=${emailSubject}&body=${emailBody}`;
    changeSharedButtonState(setEmailShared);
  }

  const shareViaText = () => {
    const smsBody = encodeURIComponent(`Check out this property listing: ${shareUrl}`);
    window.location.href = `sms:?body=${smsBody}`;
    changeSharedButtonState(setTextShared);
  }

  const shareOnFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`, 'Share on Facebook', popupOptions);
    changeSharedButtonState(setFacebookShared)
  }

  const shareOnTwitter = () => {
      window.open(`https://twitter.com/intent/tweet?url=${shareUrl}`, 'Share on Twitter', popupOptions);
      changeSharedButtonState(setTwitterShared)
  }

  const shareOnLinkedIn = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`, 'Share on LinkedIn', popupOptions);
    changeSharedButtonState(setLinkedinShared)
  }

  const shareOnReddit = () => {
    const redditShareURL = `https://www.reddit.com/submit?url=${shareUrl}`;
    window.open(redditShareURL, 'Share on Reddit', popupOptions);
    changeSharedButtonState(setRedditShared)
  }

  const shareOnWhatsApp = () => {
    const whatsappMessage = 'Check out this property listing: ' + shareUrl;
    const whatsappURL = `https://api.whatsapp.com/send?text=${whatsappMessage}`;
    window.open(whatsappURL, 'Share on WhatsApp', popupOptions);
    changeSharedButtonState(setWhatsAppShared)
  }

  // const shareOnMessenger = () => {
  //     const messengerMessage = 'Check out this property listing: ' + shareUrl;
  //     const messengerURL = `https://www.facebook.com/dialog/send?app_id=379955023799383&link=${shareUrl}&redirect_uri=${shareUrl}&quote=${messengerMessage}`;
  //     window.open(messengerURL, 'Share on Messenger', popupOptions);
  // }

  return (
    <>
      <Button
			  resetText
			  variant="flat"

        onClick={handleShow}
        label={<>Share  &nbsp; <FontAwesomeIcon icon={faShareFromSquare} /></>}
      />

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className={'share-modal'}
      >
        <Modal.Header>
          <div className='d-flex justify-content-between w-100'>
          <Modal.Title>Share Property Listing</Modal.Title>
          <Button resetText  variant="filled" color='primary' onClick={handleClose} title="Close" className='mb-4'
              label={
                    <FontAwesomeIcon icon={faXmark}/>
              }
            />
          </div>
        </Modal.Header>

        <Modal.Body className={'d-flex justify-content-around '}>
          <div className={'d-flex flex-column mx-lg-4 mx-3'}>
            <Button resetText variant="filled" color='dark-blue' onClick={handleCopyUrlClick} title="Copy Url" className='mb-4' size={userOnMobile?"sm": "md"}
              label={
                <div className='d-flex flex-column'>
                  <div>
                    <FontAwesomeIcon icon={faLink} size="2xl" beatFade={urlCopied}/>
                  </div>
                  <div>{urlCopied?"Copied!" : "Copy Url"}</div>
                </div>
              }
            />
            <Button resetText  variant="filled" color='dark-blue' onClick={shareOnFacebook} title="Facebook" className='mb-4' size={userOnMobile?"sm": "md"}
              label={
                <div className='d-flex flex-column'>
                  <div>
                    <FontAwesomeIcon icon={faFacebook} size="2xl" beatFade={facebookShared}/>
                  </div>
                  <div>Facebook</div>
                </div>
              }
            />
          </div>

          <div className={'d-flex flex-column mx-lg-4 mx-3'}>
            <Button resetText  variant="filled" color='dark-blue'  onClick={shareViaEmail}  title="Email" className='mb-4' size={userOnMobile?"sm": "md"}
              label={
                <div className='d-flex flex-column'>
                  <div>
                    <FontAwesomeIcon icon={faEnvelope} size="2xl" beatFade={emailShared}/>
                  </div>
                  <div>Email</div>
                </div>
              }
            />
            <Button resetText  variant="filled" color='dark-blue'  onClick={shareOnTwitter} title="Twitter" className='mb-4' size={userOnMobile?"sm": "md"}
              label={
                <div className='d-flex flex-column'>
                  <div>
                    <FontAwesomeIcon icon={faXTwitter} size="2xl" beatFade={twitterShared}/>
                  </div>
                  <div>Twitter</div>
                </div>
              }
            />
          </div>

          <div className={'d-flex flex-column mx-lg-4 mx-3'}>
            <Button resetText  variant="filled" color='dark-blue'  onClick={shareViaText} title="Text Message"  className='mb-4' size={userOnMobile?"sm": "md"}
              label={
              <div className='d-flex flex-column'>
                <div>
                  <FontAwesomeIcon icon={faCommentSms} size="2xl" beatFade={textShared}/>
                </div>
                <div>SMS</div>
              </div>
              }
            />
          <Button resetText  variant="filled" color='dark-blue'  onClick={shareOnLinkedIn} title="Linkedin" className='mb-4' size={userOnMobile?"sm": "md"}
            label={
              <div className='d-flex flex-column'>
                <div>
                  <FontAwesomeIcon icon={faLinkedin} size="2xl" beatFade={linkedinShared}/>
                </div>
                <div>Linkedin</div>
              </div>
            }/>
          </div>

          <div className={'d-flex flex-column mx-lg-4 mx-3'}>
            <Button resetText  variant="filled" color='dark-blue'  onClick={shareOnWhatsApp} title="WhatsApp" className='mb-4' size={userOnMobile?"sm": "md"}
              label={
                <div className='d-flex flex-column'>
                  <div>
                    <FontAwesomeIcon icon={faWhatsapp} size="2xl" beatFade={whatsAppShared}/>
                  </div>
                  <div>Whatsapp</div>
                </div>
              }/>
            <Button resetText  variant="filled" color='dark-blue'  onClick={shareOnReddit} title="Reddit" className='mb-4' size={userOnMobile?"sm": "md"}
              label={
                <div className='d-flex flex-column'>
                  <div>
                    <FontAwesomeIcon icon={faReddit} size="2xl" beatFade={redditShared}/>
                  </div>
                  <div>Reddit</div>
                </div>
              }/>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
